import request from '@/utils/request'
// 列表查询
export function getPrincipalKindergartenListData (params) {
  return request({
    url: 'users/principals/kindergartens/',
    method: 'get',
    params
  })
}

// 添加教师与专家绑定
export function addPrincipalKindergartenData (data) {
  return request({
    url: `users/principals/kindergartens/`,
    method: 'post',
    data,
    transformRequest: [
      function (data) {
        let ret = ''
        for (const it in data) {
          if (data[it]) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
        }
        ret = ret.substring(0, ret.lastIndexOf('&'))
        return ret
      }
    ],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 删除教师与专家绑定
export function deletePrincipalKindergartenData (id) {
  return request({
    url: `users/principals/kindergartens/${id}/`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/principal-kindergarten.js